import { apiClient } from './client';

export interface BranchSummary {
  id: number;
  name: string;
  code: string;
  address: string | null;
  city: string | null;
  country: string | null;
  phone: string | null;
  email: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const listBranches = async (activeOnly = false): Promise<BranchSummary[]> => {
  const { data } = await apiClient.get('/branches', { params: { activeOnly } });
  return data.data;
};

export const createBranch = async (input: {
  name: string;
  code: string;
  address?: string;
  city?: string;
  country?: string;
  phone?: string;
  email?: string;
}): Promise<BranchSummary> => {
  const { data } = await apiClient.post('/branches', input);
  return data.data;
};

export const updateBranch = async (
  id: number,
  input: Partial<{
    name: string;
    code: string;
    address: string;
    city: string;
    country: string;
    phone: string;
    email: string;
    isActive: boolean;
  }>,
): Promise<BranchSummary> => {
  const { data } = await apiClient.patch(`/branches/${id}`, input);
  return data.data;
};
